module.exports = __webpack_public_path__ + "assets/8935223e51cdee59405d4aaca3fb2c98.png";